import React from "react";
import Container from "./ui/Container";
import EyebrowTitle from "./ui/EyebrowTitle";
import EntryContent from "./ui/EntryContent";
import SiteLink from "./ui/SiteLink";
import { PortableText } from "@portabletext/react";
import { portableTextUtils } from "./sanity/portableTextUtils";
import Section from "./ui/Section";
import { GatsbyImage } from "gatsby-plugin-image";
import Button from "./ui/Button";

const GetStarted = ({ data }) => {
  const { badge, title, buildingSteps } = data;

  return (
    <Section id="start-building" className="lg:pb-42 bg-card pb-16 xl:pb-32">
      <Container>
        <div className="mb-8 lg:mb-16">
          <div className="flex max-w-screen-sm flex-col items-start">
            <EyebrowTitle label={badge} as="p" center={false} />
            <EntryContent>
              <h2>{title}</h2>
            </EntryContent>
          </div>
        </div>

        <div className="grid-row-3 grid gap-14 lg:grid-cols-3 lg:gap-6">
          {buildingSteps &&
            buildingSteps.map(
              ({ title, number, image, _rawContent, cta }, key) => (
                <div className="group flex flex-col gap-6" key={key}>
                  {image && image.asset && (
                    <SiteLink to={cta.link} external={cta.isExternal}>
                      <div className="aspect-video overflow-hidden rounded-2xl object-cover">
                        <GatsbyImage
                          image={image.asset.gatsbyImageData}
                          alt={title}
                          className="aspect-video w-full object-cover transition-transform duration-1000 group-hover:scale-105"
                        />
                      </div>
                    </SiteLink>
                  )}
                  <div className="flex grow flex-col">
                    <SiteLink
                      to={cta.link}
                      external={cta.isExternal}
                      className="flex flex-grow flex-col items-start"
                    >
                      <p className="mb-3 font-heading text-sm text-foreground/50">
                        {number}
                      </p>
                      <EntryContent className="prose-headings:mb-2 prose-headings:text-h5">
                        <h3>{title}</h3>
                        <PortableText
                          value={_rawContent}
                          components={portableTextUtils}
                        />
                      </EntryContent>
                    </SiteLink>
                    <p className="mt-8 text-center xl:text-left">
                      <Button asChild size="lg">
                        <SiteLink
                          to={cta.link}
                          external={cta.isExternal}
                          iconExternal={cta.isExternal}
                        >
                          {cta.label}
                        </SiteLink>
                      </Button>
                    </p>
                  </div>
                </div>
              )
            )}
        </div>
      </Container>
    </Section>
  );
};

export default GetStarted;
